module.exports = __webpack_public_path__ + "static/media/serviceCenterImg03.869e54e8.png";